import { headerStyles as styles } from "@bevco/Overrides/Widgets/InvoiceHistory/InvoiceHistoryHeader";

styles.invoiceCountGridItem = {
    ...styles.invoiceCountGridItem,
    width: [12, 12, 6, 6, 6],
    align: "middle",
};

styles.toggleFilterGridItem = {
    ...styles.toggleFilterGridItem,
    width: [12, 12, 6, 6, 6],
    align: "middle",
};

styles.toggleFilterButton = {
    variant: "secondary",
};
